// 単発オファー登録（投資・査定）は、日次オファー上限（同一プランナー×同一対象×同日）に
// 当たった場合、API がレコードを作成せず 200 { message, ignored: true } を返す
// （通常の 201 { id } ではない）。生成クライアントの returnType（Id）には ignored が
// 含まれないため、superagent の生レスポンス body から判定する。
// この判定を怠ると、実際には未送信なのに成功動線（「送信完了しました」）に乗ってしまう。
export const isIgnoredOfferResponse = (response: unknown): boolean =>
  (response as { body?: { ignored?: unknown } } | null | undefined)?.body?.ignored === true;

export const IGNORED_INVESTMENT_OFFER_MESSAGE =
  "本日すでにこのユーザーへ提案済みのため、送信されませんでした。";

export const IGNORED_ASSESSMENT_OFFER_MESSAGE =
  "本日すでにこの物件へ提案済みのため、送信されませんでした。";

// 単発の投資・査定提案は、送信先の会社と既にマッチ済み（別プランナー経由も含む）の場合、
// レコードを作成せず 422 { code: 'COMPANY_ALREADY_MATCHED', message } を返す。
// isIgnoredOfferResponse と同じく生のレスポンス body から判定する。
export const isCompanyAlreadyMatchedResponse = (response: unknown): boolean =>
  (response as { body?: { code?: unknown } } | null | undefined)?.body?.code === "COMPANY_ALREADY_MATCHED";

// プランナー向けの文言。ユーザー向け（「同じ会社のプランナーと既にマッチしています。」）と違い、
// 誰と誰がマッチ済みなのかを主語で明示する（API のエージェント側 422 の message と同じ文言）。
// 同僚がマッチ済み（matched_by: 'colleague'）のときの文言
export const COMPANY_ALREADY_MATCHED_MESSAGE = "同じ会社の他のプランナーが既にこのユーザーとマッチしています。";

// 本人が既にマッチ済み（matched_by: 'self'）のときの文言。「他のプランナー」では事実と違うので分ける
export const COMPANY_ALREADY_MATCHED_SELF_MESSAGE = "このユーザーはすでにマッチ済みです。";

// API の 422 body.matched_by（'self' | 'colleague'）でプランナー向け文言を出し分ける。
// matched_by が無い（古い API 応答）場合は従来どおり同僚マッチの文言にフォールバックする
export const getCompanyAlreadyMatchedMessage = (response: unknown): string =>
  (response as { body?: { matched_by?: unknown } } | null | undefined)?.body?.matched_by === "self"
    ? COMPANY_ALREADY_MATCHED_SELF_MESSAGE
    : COMPANY_ALREADY_MATCHED_MESSAGE;

// 査定提案の提供停止中（Trello #147）は、API が作成・再送信・添付を
// 403 { code: 'ASSESSMENT_PROPOSALS_DISABLED', message } で拒否する。導線はフラグで隠しているが、
// フロントのフラグと API のフラグが食い違った場合（再開作業の途中やデプロイ中の新旧混在）に
// 停止中であることを伝えるため、生のレスポンス body から判定する。
export const isAssessmentProposalsDisabledResponse = (response: unknown): boolean =>
  (response as { body?: { code?: unknown } } | null | undefined)?.body?.code === "ASSESSMENT_PROPOSALS_DISABLED";

export const ASSESSMENT_PROPOSALS_DISABLED_MESSAGE = "査定提案は現在停止中のため送信できません。";

// 単発オファー送信の失敗ログ（投資提案の画面から呼ばれる）。会社マッチ済み 422 は画面で理由を案内する
// 想定内の応答なので console.error しない。査定提案の提供停止 403 は投資提案の API では返らないためここでは見ない。
// console.error に渡した値は captureConsoleIntegration が Sentry に送るが、superagent の Response 本体
// （reject(response) した値）を渡すと文字列化されて beforeSend では判別できないため、ログ出力の時点で止める。
// response を省略した場合は error 自体（reject(response) 済みの値）を判定に使う
export const logUnexpectedOfferError = (error: unknown, response: unknown = error): void => {
  if (isCompanyAlreadyMatchedResponse(response)) return;
  console.error(error);
};
